import React from 'react';
import { Box, Flex } from '@chakra-ui/core';
import { getVisibleQuoteProgress } from './QuoteProgressTimeline';

export const STAGE_COLORS = ['coral.400', 'tag.secondaryBg.red', 'coral.900', 'coral.700', 'red'];

const QuoteProgressSegments = ({ quote }) => {
  const { current, total } = getVisibleQuoteProgress(quote);
  if (!current) return null;

  return (
    <Flex
      mt={2}
      gridGap={1}
      maxW="170px"
      role="progressbar"
      aria-label="Avancement du dossier"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-valuetext={`Étape ${current} sur ${total}`}
    >
      {Array.from({ length: total }, (_, index) => (
        <Box
          key={index}
          flex={1}
          h="5px"
          rounded="full"
          bg={index < current ? STAGE_COLORS[index] : 'lightGray3'}
          aria-hidden="true"
        />
      ))}
    </Flex>
  );
};

export default QuoteProgressSegments;
